import alt from 'components/Dispatcher';

class AdminFormDataActions {
  constructor() {
    this.generateActions(
      'fetchFormData',
      'fetchFormDataLoading',
      'fetchFormDataSuccess',
      'fetchFormDataError',
      'formDataUpdated',
      'addNewTeam'
    );
  }
}

export default alt.createActions(AdminFormDataActions);
